import apiClient from '../api/axios';

export const createCommittee = async (data: any) => {
  const response = await apiClient.post('/committee', data);

  return response.data;
};
